export enum FormStep {
  One = 1,
  Two,
  Three,
  Four,
}
